import React from 'react';
import ReactDOM from 'react-dom';

import App from 'src/containers/App';
import buildStore from 'src/redux/store';
import { create } from 'axios';

// eslint-disable-next-line import/no-unassigned-import
import '@grupa-pracuj/react-pagination/dist/index.css';


const bootstrapApplication = ({ libraryName, baseURL, timeout }) => {
  const root = document.querySelector(`#${libraryName}-markup`);
  if (!root) return false;

  const http = create({
    baseURL,
    withCredentials: true,
    timeout
  });

  const store = buildStore({
    name: libraryName,
    middlewares: {
      http
    },
    state: window[`${libraryName}`]
  });

  return ReactDOM.hydrate(<App store={ store } />, root);
};

export default bootstrapApplication;
